export class Deslocamento {
    titulo: string;
    descricao: string;
    observacao: string;
    justificativa: string;
    destinoId: number;
    status: number;
    tipo: number;
    tipoViagemId: number;
    solicitanteId: number;
    dataHoraPrevistaSaida: string;
    dataHoraEfetivaSaida: string;
    dataHoraPrevistaRetorno: string;
    dataHoraEfetivaRetorno: string;
    enderecoPartidaSolicitante: string;
    enderecoPartidaVeiculo: string;
    kmSaida: number;
    kmRetorno: number;
    motoristaDesignadoId: number;
    bemId: number;
    numeroRequisicao: number;
    areaId: number;
    dataCriacao: string;
    dataUltimaAlteracao: string;
    ativo: boolean;
    id: number;
    usuarioCriacaoId: number;
    usuarioUltimaAlteracaoId: number;
}

export class CustoDeslocamento {
    dataCriacao: string; 
    dataUltimaAlteracao: string; 
    ativo: boolean; 
    deslocamentoId: number; 
    descricao: string; 
    valor: number; 
    observacao: string; 
    comprovante: string; 
    id: number; 
    usuarioCriacaoId: number; 
    usuarioUltimaAlteracaoId: number;
}


/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/viagens/deslocamentos/shared/deslocamento.model.ts
 **/